import * as Phaser from "phaser-ce"
import { ActivityKey } from "../../../shared/models/ActivityKey"
import { loadGenericAssets } from "../../generic-sprites/GenericAssets"
import { Scale } from "../../utils/Scale"
import { Transitions } from "../transitions/Transitions"
import { loadAssets } from "./EveryCigAssets"
import { EveryCigStateShared, initializeEveryCigStateShared } from "./EveryCigState"
import { EveryCigSpriteType } from "./EveryCigTypes"
import { EveryCigBodyPartButtonContainer } from "./sprites/EveryCigBodyPartButtonContainer"
import { EveryCigDropdownScreenContainer } from "./sprites/EveryCigDropdownScreenContainer"
import { EveryCigSpriteCreator } from "./sprites/EveryCigSpriteCreator"
import { EveryCigViewVotesScreenOptionContainer } from "./sprites/EveryCigViewVotesScreenOptionContainer"


export class EveryCig2State extends Phaser.State implements EveryCigStateShared {

    sprites: EveryCigSpriteCreator
    buttons: EveryCigBodyPartButtonContainer

    async preload() {
        loadGenericAssets(this.game)
        loadAssets(this.game, 2)
    }

    async create() {
        await initializeEveryCigStateShared(this)
        this.createVotingScreen()
    }

    private startOutro = () => {
        Transitions.startOutro(this.game, ActivityKey.EVERY_CIG_2)
    }

    private createVotingScreen = () => {
        const screen = this.createDropdownScreen()
        const onZoomIn = () => {
            EveryCigViewVotesScreenOptionContainer.display(
                this.game,
                this.game.add.group(),
                Scale.x(0.573),
                Scale.y(0.065)
            )
        }
        screen.addClose(() => {
            screen.destroy()
            this.startOutro()
        })
        screen.zoomIn(onZoomIn)
    }

    private createDropdownScreen = (): EveryCigDropdownScreenContainer =>
        this.sprites.create(EveryCigSpriteType.VOTE_SCREEN, {
            x: Scale.x(0.491),
            y: Scale.y(-0.542)
        }) as EveryCigDropdownScreenContainer
}
